import { render, staticRenderFns } from "./expo-matching-grant.vue?vue&type=template&id=7ec5d6ee"
import script from "./expo-matching-grant.vue?vue&type=script&lang=js"
export * from "./expo-matching-grant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports